import React from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Modal,
  Pressable,
} from 'react-native';
import { Text } from '@/components/common/text';
import { useLinkedAccountsColors } from '@/constants/residents/mobile/linkedAccountsColors';
import { SVG_COMPONENTS } from '@/assets/admin';

const CancelX = SVG_COMPONENTS.CANCEL_X;

interface EmailPopupModalProps {
  visible: boolean;
  email: string;
  onClose: () => void;
}

/**
 * Email Popup Modal Component
 * Bottom sheet style modal for showing full email address
 * Matches Figma design 1.b
 */
export const EmailPopupModal: React.FC<EmailPopupModalProps> = ({
  visible,
  email,
  onClose,
}) => {
  const LAC = useLinkedAccountsColors();

  return (
    <Modal
      visible={visible}
      transparent
      animationType="slide"
      onRequestClose={onClose}
    >
      <Pressable style={styles.overlay} onPress={onClose}>
        <Pressable
          style={[styles.bottomSheet, { backgroundColor: LAC.cardBackground }]}
          onPress={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={onClose}
              activeOpacity={0.7}
              accessibilityRole="button"
              accessibilityLabel="Close"
            >
              <CancelX width={16} height={16} color={LAC.textMuted} />
            </TouchableOpacity>
          </View>

          {/* Email content */}
          <View style={styles.content}>
            <Text style={[styles.emailText, { color: LAC.textPrimary }]} selectable>
              {email}
            </Text>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  bottomSheet: {
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    paddingTop: 24,
    paddingHorizontal: 24,
    paddingBottom: 40,
    width: '100%',
    maxWidth: 375,
    alignSelf: 'center',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 16,
  },
  closeButton: {
    width: 20,
    height: 27,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    minHeight: 200,
  },
  emailText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 21,
  },
});

